export default [ 'inspur', 'zxh', 'pax', 'ksxjdx' ];



// WEBPACK FOOTER //
// ./src/DATA/enterprise-list.js